import type { AccessScopeFilter } from "../constants/access.constants";

/**
 * The tenancy filter, shared by roles and policies: both entities carry the same `organization_id | null`,
 * where `null` means the row is Coloca-owned and global.
 *
 * Pure and exported so it can be tested directly — the repo's way of covering hook logic (see
 * `chunkStatementTransactions` in `cards/hooks/useStatementPagination.ts`).
 */
export function matchesScope(organizationId: string | null | undefined, scope: AccessScopeFilter): boolean {
  if (scope === "global") return !organizationId;
  if (scope === "org") return !!organizationId;
  return true;
}

/** Lowercased and trimmed, once per keystroke instead of once per row. Empty means "no search". */
export function normalizeSearchTerm(query: string): string {
  return query.trim().toLowerCase();
}
